import type { FC } from "react";
import { useEffect } from "react";

import { trackEvent } from "../../../common/tracking/trackerService";
import type { NotificationResult } from "../../../services/notifications/notificationsActions";
import { NotificationContextProvider } from "../context/NotificationContext";
import { BaseToast } from "./BaseToast";
import {
  BookingResultContent,
  getBookingResultHeaderProps,
} from "./getBookingResultParams";

export interface BookingResultToastContentProps {
  closeToast: () => void;
  result: NotificationResult;
}

export const BookingResultToastContent: FC<BookingResultToastContentProps> = ({
  result,
  closeToast,
}) => {
  const { title, icon, iconBackgroundColor } =
    getBookingResultHeaderProps(result);

  useEffect(() => {
    trackEvent({ category: "Toast", action: "Appear (booking result)" });
  }, []);

  return (
    <NotificationContextProvider
      value={{ trackerCategory: "Toast", onRequestClose: closeToast }}
    >
      <BaseToast
        icon={icon}
        title={title}
        onClose={closeToast}
        iconBackgroundColor={iconBackgroundColor}
      >
        <BookingResultContent result={result} />
      </BaseToast>
    </NotificationContextProvider>
  );
};
